/* Homeli motion: scroll reveals with graceful fallback */
(function () {
  var docEl = document.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  docEl.classList.add('hm-js');
  var reveal = function () {
    var sections = document.querySelectorAll('main .shopify-section');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hm-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    sections.forEach(function (s) { io.observe(s); });
    /* safety: everything visible after 3s regardless */
    setTimeout(function () {
      sections.forEach(function (s) { s.classList.add('hm-in'); });
    }, 3000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();